export const EXTENSION_LINK =
  'https://chrome.google.com/webstore/detail/asigna-multisig/gopddoinbenlokghakiafackadkbnlid';
